import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";

/**
 * Post-login landing decision.
 *
 * Default destination is the Cases Portal. Users who don't have Cases access
 * but do have Smile access land on the Smile Portal profile page instead.
 */
const AuthRedirector = () => {
  const location = useLocation();
  const { user } = useAppSelector((state) => state.auth);

  const ref = new URLSearchParams(location.search).get("ref");
  const refSuffix = ref ? `?ref=${encodeURIComponent(ref)}` : "";

  const isSuperAdmin = user?.role?.toLowerCase() === "super admin";
  const isStaff = !!user && user.role !== "User";
  const hasCasesAccess = !!user?.verified || isStaff || isSuperAdmin;
  const hasSmileAccess = !!user?.verifySmile || isSuperAdmin;
  const hasPhotoRecolourAccess =
    isSuperAdmin || (user?.role === "User" && !!user?.verifyPhotoRecolour);

  // No Cases access but has Smile access -> Smile Portal profile.
  if (!hasCasesAccess && hasSmileAccess) {
    return <Navigate to={`/dashboard/smiledesign/profile`} replace />;
  }

  // No Cases / Smile access but has Photo Recolour -> standalone studio.
  if (!hasCasesAccess && hasPhotoRecolourAccess) {
    return <Navigate to="/dashboard/photo-recolour" replace />;
  }

  // Production portal users work from allocation by default.
  if (user?.role === "Production") {
    return <Navigate to="/dashboard/allocation/unallocated" replace />;
  }

  // Default (Cases access, or brand-new onboarding users) -> Cases Portal.
  return <Navigate to={`/dashboard/profile${refSuffix}`} replace />;
};

export default AuthRedirector;
